<template>
    <div id="WaitingRoom">
        <div class="d-flex flex-column justify-content-center align-items-center py-5 my-3">
            <h1 class="waiting-room-title brand-secondary">You're Early!</h1>
            <div class="waiting-room-meta d-flex flex-row flex-nowrap">
                <span>Service Provider: {{ coach.name }}</span>
                <span class="mx-4">|</span>
                <span><i class="fas fa-clock brand-secondary" aria-hidden="true"></i>
                    {{ getHoursMinutes(booking.start) }} -
                    {{ getHoursMinutes(booking.end) }}
                </span>
            </div>
            <div class="waiting-room-video-container d-flex flex-column justify-content-center align-items-center">
                <div class="waiting-room-video d-flex justify-content-center align-items-center">
                    <div class="waiting-room-countdown">
                        <div class="waiting-room-counter">
                            Session Starting In<br />
                          <span class="waiting-room-timer" v-if="days">{{ days }} {{days > 1 ? 'days' : 'day'}}</span>
                            <span class="waiting-room-timer"
                                v-else-if="hours !== ''">{{ hours }}:{{ minutes }}:{{ seconds }}</span>
                        </div>
                        <Loader />
                    </div>
                </div>
            </div>
            <p class="waiting-room-p">
                Wait here for your session to start or alternatively check back close to when your session is due to
                start.
            </p>
            <b-button class="cta-button px-5" @click="close()">Close</b-button>
        </div>
    </div>
</template>
<script>
import Loader from "@/components/Loader";
import {
    getAppointmentCountdownParts,
    getMillisecondsUntilAppointment
} from "@/utils/appointmentTimezone";

export default {
    components: {
        Loader
    },
    props: ['booking', 'coach'],
    name: "WaitingRoom",
    data() {
        return {
            isEarly: true,
            timeRemaining: '',
            intervalFunction: '',
            seconds: '',
            minutes: '',
            hours: '',
            days: ''
        };
    },
    mounted() {
        if (this.updateCountdown()) {
            this.intervalFunction = setInterval(() => {
                this.updateCountdown();
            }, 1000);
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalFunction);
    },
    methods: {
        updateCountdown() {
            const diffMs = getMillisecondsUntilAppointment(this.getCountdownAppointment());

            if (diffMs === null) {
                return true;
            }

            if (diffMs <= 0) {
                clearInterval(this.intervalFunction);
                this.updateParentTimeout();
                return false;
            }

            const countdown = getAppointmentCountdownParts(diffMs);
            this.days = countdown.days;
            this.hours = countdown.hours;
            this.minutes = countdown.minutes;
            this.seconds = countdown.seconds;

            if (diffMs < 1500) {
                clearInterval(this.intervalFunction);
                this.updateParentTimeout();
                return false;
            }

            return true;
        },
        getCountdownAppointment() {
            return {
                startTime: this.booking?.start,
                endTime: this.booking?.end
            };
        },
        updateParentTimeout() {
            this.$emit('timeoutOver')
        },
        close() {
            this.$bvModal.hide("digital_clinics_modal");
        },
    },

};
</script>
<style lang="less">
#WaitingRoom {
    .waiting-room-title {
        font-weight: bold;
        padding-bottom: 1.5rem;
    }

    .waiting-room-meta {
        font-size: 1.6rem;
        padding-bottom: 1.5rem;
    }

    .waiting-room-video-container {
        max-width: 600px;
        width: 100%;
        aspect-ratio: 16/9;
        position: relative;
        margin-bottom: 1.5rem;
        display: flex;

        .waiting-room-video {
            background: rgb(15,15,15);
            background: linear-gradient(225deg, rgba(15,15,15,1) 0%, rgba(97,97,97,1) 73%, rgba(28,28,28,1) 100%);
            width: 100%;
            flex-grow: 1;
        }
    }

    .waiting-room-counter {
        text-align: center;
        color: white;
        font-size: 1.8rem;

        .waiting-room-timer {
            font-size: 3.6rem;
            font-weight: bold;
        }
    }

    .waiting-room-p {
        max-width: 600px;
        text-align: center;
        font-size: 1.6rem;
        padding-bottom: 1.5rem;
    }
}
</style>